module.exports = __webpack_public_path__ + "img/img_sample4.c2bf717e.jpg";